import { capitalizeIfLower } from '@btime/helpers'

// TODO: Refactor to use recursive function
const formatLocalPersonLabel = item => {
  const name = capitalizeIfLower(item.name || item.placeLevel?.name) || ''
  const father = capitalizeIfLower(item.parent?.name || item.placeLevel?.parent?.name) || ''
  const grandFather = capitalizeIfLower(item.parent?.parent?.name || item.placeLevel?.parent?.parent?.name) || ''

  return `${name}${father ? ' - ' + father : ''}${grandFather ? ' - ' + grandFather : ''}`
}

export default formatLocalPersonLabel
